import { testimonials } from "@/mocks/comic";

const avatarTone = [
  "bg-primary-500 text-background-50",
  "bg-accent-500 text-background-50",
  "bg-secondary-500 text-background-50",
  "bg-foreground-800 text-background-50",
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="paper-bg">
      <div className="container-paper py-14 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-xs tracking-[0.18em] text-primary-600">
            <i className="ri-heart-3-line text-sm leading-none" aria-hidden="true"></i>
            读者口碑
          </span>
          <h2 className="mt-3 font-display text-3xl text-foreground-950 md:text-4xl">
            翻开纸盒的人，都在说
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            这些来自复古漫画与纸质阅读爱好者的真实感受，也是纸盒一直坚持的方向。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2">
          {testimonials.map((t, idx) => (
            <figure
              key={t.name}
              className="relative rounded-lg border border-background-300 bg-background-50 p-6 md:p-7"
            >
              <i
                className="ri-double-quotes-l text-4xl leading-none text-primary-200"
                aria-hidden="true"
              ></i>
              <blockquote className="mt-3 text-sm leading-7 text-foreground-700">{t.text}</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-background-200 pt-5">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-full font-display text-lg ${avatarTone[idx % avatarTone.length]}`}
                >
                  {t.name.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-950">{t.name}</span>
                  <span className="text-xs text-foreground-500">{t.role}</span>
                </span>
                <span className="ml-auto flex items-center gap-0.5 text-accent-600">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <i key={i} className="ri-star-fill text-sm leading-none" aria-hidden="true"></i>
                  ))}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}